import { render, staticRenderFns } from "./ComplexRegionalPain.vue?vue&type=template&id=dcd6ad62&scoped=true"
import script from "./ComplexRegionalPain.vue?vue&type=script&lang=js"
export * from "./ComplexRegionalPain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd6ad62",
  null
  
)

export default component.exports